import React, { Component } from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'

export default class MarginPaddingHolder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            expanded: false,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            disabled: false,
            showToggle: true
        }

        this.changeValue = this.changeValue.bind(this)
        this.toggleExpanded = this.toggleExpanded.bind(this)
    }

    componentDidMount() {
        let paddingLeft = this.props?.clusterMembers?.find((c) => c.props.title == 'Left')
        let paddingRight = this.props?.clusterMembers?.find((c) => c.props.title == 'Right')
        let paddingTop = this.props?.clusterMembers?.find((c) => c.props.title == 'Top')
        let paddingBottom = this.props?.clusterMembers?.find((c) => c.props.title == 'Bottom')

        let paddingLeftValue = paddingLeft?.props.value || '0'
        let paddingRightValue = paddingRight?.props.value || '0'
        let paddingTopValue = paddingTop?.props.value || '0'
        let paddingBottomValue = paddingBottom?.props.value || '0'

        paddingLeftValue = paddingLeftValue.replace('px', '')
        paddingRightValue = paddingRightValue.replace('px', '')
        paddingTopValue = paddingTopValue.replace('px', '')
        paddingBottomValue = paddingBottomValue.replace('px', '')

        let expanded = false
        if (paddingLeftValue === paddingRightValue && paddingTopValue === paddingBottomValue) expanded = true

        let showToggle = true
        if (
            paddingLeft?.props.elementData.showToggle === false ||
            paddingRight?.props.elementData.showToggle === false ||
            paddingTop?.props.elementData.showToggle === false ||
            paddingBottom?.props.elementData.showToggle === false
        ) {
            showToggle = false
        }

        this.setState({
            expanded,
            paddingLeft: paddingLeftValue,
            paddingRight: paddingRightValue,
            paddingTop: paddingTopValue,
            paddingBottom: paddingBottomValue,
            showToggle
        })
    }

    async changeValue(name, value) {
        let finalValue = value
        const isValidValue = value && !isNaN(value)
        if (isValidValue) {
            finalValue = value + 'px'
        }

        switch (name) {
            case 'marginLeftRight':
            case 'paddingLeftRight': {
                this.setState({ paddingLeft: value, paddingRight: value })

                if (isValidValue) {
                    const leftMember = this.props.clusterMembers.find((c) => c.props.title === 'Left')
                    const rightMember = this.props.clusterMembers.find((c) => c.props.title === 'Right')

                    if (leftMember && rightMember) {
                        await this.props.updateVal([leftMember.props.path, rightMember.props.path], finalValue)
                    }
                }

                break
            }
            case 'marginTopBottom':
            case 'paddingTopBottom': {
                this.setState({ paddingTop: value, paddingBottom: value })

                if (isValidValue) {
                    const topMember = this.props.clusterMembers.find((c) => c.props.title === 'Top')
                    const bottomMember = this.props.clusterMembers.find((c) => c.props.title === 'Bottom')
                    if (topMember && bottomMember) {
                        await this.props.updateVal([topMember.props.path, bottomMember.props.path], finalValue)
                    }
                }
                break
            }
            case 'marginLeft':
            case 'paddingLeft': {
                this.setState({ paddingLeft: value })
                if (isValidValue) {
                    const leftMember = this.props.clusterMembers.find((c) => c.props.title === 'Left')
                    if (leftMember) {
                        await this.props.updateVal(leftMember.props.path, finalValue)
                    }
                }
                break
            }
            case 'marginRight':
            case 'paddingRight': {
                this.setState({ paddingRight: value })

                if (isValidValue) {
                    const rightMember = this.props.clusterMembers.find((c) => c.props.title === 'Right')
                    if (rightMember) {
                        await this.props.updateVal(rightMember.props.path, finalValue)
                    }
                }
                break
            }
            case 'marginTop':
            case 'paddingTop': {
                this.setState({ paddingTop: value })

                if (isValidValue) {
                    const topMember = this.props.clusterMembers.find((c) => c.props.title === 'Top')
                    if (topMember) {
                        await this.props.updateVal(topMember.props.path, finalValue)
                    }
                }
                break
            }
            case 'marginBottom':
            case 'paddingBottom': {
                this.setState({ paddingBottom: value })

                if (isValidValue) {
                    const bottomMember = this.props.clusterMembers.find((c) => c.props.title === 'Bottom')
                    if (bottomMember) {
                        await this.props.updateVal(bottomMember.props.path, finalValue)
                    }
                }
                break
            }
        }
    }

    async toggleExpanded() {
        if (!this.state.expanded) {
            await this.changeValue('paddingTopBottom', this.state.paddingTop)
            await new Promise((resolve) => setTimeout(resolve, 100)) //Need to wait for state to update, will make this better in the future up a level
            await this.changeValue('paddingLeftRight', this.state.paddingLeft)
            this.setState({ disabled: true })
        }
        this.setState({ disabled: false, expanded: !this.state.expanded })
    }

    render() {
        if (this.state.expanded) {
            return (
                <div className='dndEditorv2-dd_toolHolder dndEditorv2-margin-padding-holder'>
                    <span className='dndEditorv2-margin-padding-holder-label'>
                        {this.props.type == 'padding' ? 'Padding' : 'Margin'}
                    </span>
                    <div className='dd_inputTool dndEditorv2-margin-padding-holder-InputsHolder'>
                        <TextInput
                            disabled={this.state.disabled}
                            value={this.state.paddingTop}
                            iconLeft={
                                <Icons
                                    color={'#4B4B4B'}
                                    icon={this.props.type == 'padding' ? 'paddingTopBottom' : 'marginTopBottom'}
                                />
                            }
                            name='paddingTopBottom'
                            onChange={(e) => {
                                this.changeValue('paddingTopBottom', e.target.value)
                            }}
                        />
                        <TextInput
                            disabled={this.state.disabled}
                            value={this.state.paddingLeft}
                            iconLeft={
                                <Icons
                                    color={'#4B4B4B'}
                                    icon={this.props.type == 'padding' ? 'paddingLeftRight' : 'marginLeftRight'}
                                />
                            }
                            name='paddingLeftRight'
                            onChange={(e) => this.changeValue('paddingLeftRight', e.target.value)}
                        />
                        {this.state.showToggle && (
                            <div className='dndEditorv2-margin-padding-holder-InputsHolder-Expander'>
                                <Icons color={'#4B4B4B'} icon='paddingExpander' onClick={this.toggleExpanded} />
                            </div>
                        )}
                    </div>
                </div>
            )
        }

        return (
            <div className='dndEditorv2-dd_toolHolder dndEditorv2-margin-padding-holder'>
                <span className='dndEditorv2-margin-padding-holder-label'>
                    {this.props.type == 'padding' ? 'Padding' : 'Margin'}
                </span>
                <div className='dd_inputTool dndEditorv2-margin-padding-holder-expandedInputsHolder'>
                    <div className='dndEditorv2-margin-padding-holder-expandedInputsHolder-inner'>
                        <div className='dndEditorv2-margin-padding-holder-expandedInputsHolder-inner-row'>
                            <TextInput
                                disabled={this.state.disabled}
                                iconLeft={
                                    <Icons
                                        color={'#4B4B4B'}
                                        icon={this.props.type == 'padding' ? 'paddingTop' : 'marginTop'}
                                    />
                                }
                                value={this.state.paddingTop}
                                name='paddingTop'
                                onChange={(e) => this.changeValue('paddingTop', e.target.value)}
                            />
                            <TextInput
                                disabled={this.state.disabled}
                                iconLeft={
                                    <Icons
                                        color={'#4B4B4B'}
                                        icon={this.props.type == 'padding' ? 'paddingLeft' : 'marginLeft'}
                                    />
                                }
                                value={this.state.paddingLeft}
                                name='paddingLeft'
                                onChange={(e) => this.changeValue('paddingLeft', e.target.value)}
                            />
                        </div>
                        <div className='dndEditorv2-margin-padding-holder-expandedInputsHolder-inner-row'>
                            <TextInput
                                disabled={this.state.disabled}
                                iconLeft={
                                    <Icons
                                        color={'#4B4B4B'}
                                        icon={this.props.type == 'padding' ? 'paddingBottom' : 'marginBottom'}
                                    />
                                }
                                value={this.state.paddingBottom}
                                name='paddingBottom'
                                onChange={(e) => this.changeValue('paddingBottom', e.target.value)}
                            />
                            <TextInput
                                disabled={this.state.disabled}
                                iconLeft={
                                    <Icons
                                        color={'#4B4B4B'}
                                        icon={this.props.type == 'padding' ? 'paddingRight' : 'marginRight'}
                                    />
                                }
                                value={this.state.paddingRight}
                                name='paddingRight'
                                onChange={(e) => this.changeValue('paddingRight', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='dndEditorv2-margin-padding-holder-expandedInputsHolder-Expander'>
                        <Icons
                            color={'#4B4B4B'}
                            icon='paddingExpander'
                            onClick={this.toggleExpanded}
                            outerStyle={{ height: 17 }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
